
<template>
  <div class="page-class page-login">
    <b-container class="my-5">
      <b-row align-v="center" align-h="center" align-content="center">
        <b-col class="text-center" sm="10" md="8" lg="5">
          <img src="../assets/images/logo.png" width="100" />
          <b-card-group deck class="mt-3">
            <b-card>
              <h1>Password Reset</h1>
              <p class="text-muted">Reset Your Password</p>
              <password-reset-box />
            </b-card>
          </b-card-group>
          <br />
          &copy; {{ thisYear }}
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PasswordResetBox from '../components/PasswordResetBox.vue';

export default {
  name: 'ResetPassword',
  components: { PasswordResetBox },
  metaInfo: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: 'Login backend with your account.'
      }
    ]
  },
  mounted() {
    if (this.$route.query.messageKey) {
      this.handleAuthMessageKey({ messageKey: this.$route.query.messageKey });
    }
  },
  methods: {
    ...mapActions('auth', ['handleAuthMessageKey'])
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
